import { Inject, Injectable } from '@angular/core';
import { PaginationResponse } from '@datorama/akita';
import { Observable } from 'rxjs';
import { EmployeeInfo } from 'src/app/api/models/employees/employees.intrface';
import { SystemEmployeesFilter } from '../employee.interface';
import { SystemEmployeesStore } from './system-employees.store';
import { API_CLIENT_EMPLOYEES_SERVICE } from 'src/app/api/injectors/api-client-employees.token';
import { BaseApiClientEmployeesService } from 'src/app/api/base-api-client-employees.service';

@Injectable({
	providedIn: 'root'
})
export class SystemEmployeesService  {

	constructor(
		@Inject(API_CLIENT_EMPLOYEES_SERVICE) private apiClientEmployeesService: BaseApiClientEmployeesService,
		private systemEmployeesStore: SystemEmployeesStore,
	) {	}

	getPaginatedEmployeesBySystem(systemId: string, page: number, perPage: number, filterBy: SystemEmployeesFilter): Observable<PaginationResponse<EmployeeInfo>> {
		return this.apiClientEmployeesService.getPaginatedEmployeesBySystem(systemId, page, perPage, filterBy);
	}

	resetStore(): void {
		this.systemEmployeesStore.reset();
	}
}
